<template>
    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
    >
        <v-toolbar color="primary darken-1" dark>
            <img :alt="App.app_name" :src="$t('app.assets.logo')" height="36"/>
            <v-toolbar-title class="ml-0 pl-3">
                <span class="hidden-sm-and-down">{{ App.app_name }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-list
            dense>
            <!-- V-For Links From Menu -->
            <!-- Individual Link (Custom Additional) -->
            <v-link
                title="Dashboard"
                href="/dashboard"
                icon="fa-home"
            />
            <v-link
                v-if="$canAccessRoute('appointments-index')"
                title="Calendar"
                :href="{ name: 'appointments-index' }"
                icon="fa-calendar"
            />
            <v-list-group v-if="$canAccessAnyRoute(['suppliers-index', 'customers-index','employees-index','vehicles-index','accounts-index'])" prepend-icon="mdi-account-circle">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>Fisiere</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item v-if="$canAccessRoute('suppliers-index')">
                    <v-link
                        title="Furnizori"
                        :href="{ name: 'suppliers-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('customers-index')">
                    <v-link
                        title="Cursanti"
                        :href="{ name: 'customers-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('employees-index')">
                    <v-link
                        title="Personal"
                        :href="{ name: 'employees-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('vehicles-index')">
                    <v-link
                        title="Parc Auto"
                        :href="{ name: 'vehicles-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('accounts-index')">
                    <v-link
                        title="Conturi / Casa"
                        :href="{ name: 'accounts-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
            </v-list-group>
            <v-list-group v-if="$canAccessAnyRoute(['transfers-index','payments-index','transactions-index','invoices-index','vehicle-fuels-index','vehicle-maintenances-index','vehicle-expenses-index'])" prepend-icon="mdi-account-circle">
                <template v-slot:activator>
                    <v-list-item-title>Operatiuni</v-list-item-title>
                </template>

                <v-list-group no-action sub-group>
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Incasari si plati</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-link v-if="$canAccessRoute('transfers-index')" title="Transferuri" :href="{ name: 'transfers-index' }"/>
                    <v-link v-if="$canAccessRoute('payments-index')" title="Plati" :href="{ name: 'payments-index' }"/>
                    <v-link v-if="$canAccessRoute('transactions-index')" title="Lista tranzactii" :href="{ name: 'transactions-index' }"/>
                    <v-link v-if="$canAccessRoute('invoices-index')" title="Lista facturi emise" :href="{ name: 'invoices-index' }"/>
                </v-list-group>

                <v-list-group v-if="$canAccessAnyRoute(['vehicle-fuels-index','vehicle-maintenances-index','vehicle-expenses-index'])" no-action sub-group>
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Auto</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-link v-if="$canAccessRoute('vehicle-fuels-index')" title="Alimentari" :href="{ name: 'vehicle-fuels-index' }"/>
                    <v-link v-if="$canAccessRoute('vehicle-maintenances-index')" title="Reparatii si revizii" :href="{ name: 'vehicle-maintenances-index' }"/>
                    <v-link v-if="$canAccessRoute('vehicle-expenses-index')" title="Impozite/RCA/ITP" :href="{ name: 'vehicle-expenses-index' }"/>
                </v-list-group>
            </v-list-group>

            <v-list-group v-if="$canAccessAnyRoute(['reports-account-report','reports-account-transaction-report'])" prepend-icon="mdi-account-circle">
                <template v-slot:activator>
                    <v-list-item-title>Rapoarte</v-list-item-title>
                </template>

                <v-list-item v-if="$canAccessRoute('reports-account-report')">
                    <v-link
                        title="Raport conturi"
                        :href="{ name: 'reports-account-report' }"
                        icon="supervisor_account"
                    />
                </v-list-item>

                <v-list-item v-if="$canAccessRoute('reports-account-transaction-report')">
                    <v-link
                        title="Raport tranzactii conturi"
                        :href="{ name: 'reports-account-transaction-report' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
            </v-list-group>

            <v-list-group v-if="$canAccessAnyRoute(['admin-users-and-roles-index', 'admin-configuration-index'])" prepend-icon="mdi-account-circle">
                <template v-slot:activator>
                    <v-list-item-title>Administrare</v-list-item-title>
                </template>

                <v-list-item v-if="$canAccessRoute('admin-users-and-roles-index')">
                    <v-link
                        title="Operatori si permisiuni"
                        :href="{ name: 'admin-users-and-roles-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>

                <v-list-item v-if="$canAccessRoute('admin-configuration-index')">
                    <v-link
                        title="Configuratii"
                        :href="{ name: 'admin-configuration-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
            </v-list-group>

            <v-subheader>Utilizator</v-subheader>
            <!--<v-link
                v-if="isAuthenticated"
                title="Contul meu"
                href="/contul-meu"
                icon="fa-cogs"
            />-->
            <v-link
                v-if="isAuthenticated"
                title="Deconectare"
                href="/auth/logout"
                icon="power_settings_new"
            />
            <!-- Guest Links -->
            <v-link
                v-if="!isAuthenticated"
                title="Autentificare"
                href="/auth/login'"
                icon="fa-key"
            />
            <v-link
                v-if="!isAuthenticated"
                title="Inregistrare"
                href="/auth/register"
                icon="fa-user-plus"
            />
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    import VLink from "../components/VLink.vue";
    import ACL from "Mixins/acl";
    import {createNamespacedHelpers} from "vuex";
    const { mapState } = createNamespacedHelpers("auth");

    export default {
        components: {
            VLink
        },
        mixins: [
            ACL
        ],
        data: () => ({
            drawer: false
        }),
        computed: {
            ...mapState({
                isAuthenticated: "isAuthenticated",
            })
        },
        mounted() {
            let self = this;
            Bus.$on("toggleDrawer", function () {
                self.drawer = !self.drawer;
            });
        }
    };
</script>
